// extracted by mini-css-extract-plugin
export default {"stack":"JqooP","inactived":"QK_jF","pattern":"avjFz"};